import { useMemo } from 'react'

export function useFormattedDate(rawDate?: string | Date): string {
  return useMemo(() => {
    if (!rawDate) return ''

    const date = new Date(rawDate)
    if (isNaN(date.getTime())) return ''

    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    }).format(date)
  }, [rawDate])
}
